import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@riise/core/services/firebase/auth.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationsService } from '@riise/core/services/notifications/notifications.service';
import { NotificationPush } from '@riise/shared/directives/notification-push.directive';
import { NotificationSound } from '@riise/shared/directives/notification-sound.directive';
import { UserData } from '@riise/shared/utils/constants/users';

import { CryptoService } from '@riise/core/services/crypto/crypto.service';



@Injectable({
  providedIn: 'root',
})
export class NotificationDirective {
  private notificationsService = inject(NotificationsService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private userData = inject(UserData);

  private NotificationPush = inject(NotificationPush);
  private NotificationSound = inject(NotificationSound);
  private crypto = inject(CryptoService);


  private notification = new BehaviorSubject<string>('null');
  notification$ = this.notification.asObservable();
  newNotificationId: any
  userId = this.userData?.userId;
  userInfos = this.userData?.userInfos;




  updateNotification(newValue: string) {
    this.notification.next(newValue);
    this.NotificationSound.sound()
  }




  newNotification(){
    this.notificationsService.getNewRequestNotification(
        this.userId.toString()
    ).subscribe((result: any) => {
      if(result?.data?.newNotification != null){
        this.updateNotification(result?.data?.newNotification);
        this.NotificationPush.showNotification(result?.data?.newNotification?.description)
      }
    });
  }

  /** Inserted by Angular inject() migration for backwards compatibility */




  constructor() {
    this.newNotification()
  }




}
